import { IconButton, InputAdornment, TextField } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import "../widgets/Listwidget.css";
import React, { useState, useEffect } from "react";
import { ReactComponent as DeleteSvg } from "../../../components/icon/delete.svg";
import { ReactComponent as EditSvg } from "../../../components/icon/edit.svg";
import { ReactComponent as SearchSvg } from "../../../components/icon/search.svg";
import { ReactComponent as FilterStack } from "../../../components/icon/filterstack.svg";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import DeletePrompt from "../common-component/DeletePrompt";
import SearchInput from "../../../components/SearchInput";
import FilterMenu from "../../../components/FilterMenu";
import {
  showErrorToast,
  showSuccessToast,
  showWarningToast,
} from "../../../components/ToastComponent";
import ToastComponent from "../../../components/ToastComponent";
import Breadcrumb from "../../../components/bootstrap/Breadcrumb";
import { CardHeader } from "../../../components/bootstrap/Card";

interface RolesDetail {
  id: number;
  name: string;
}

interface WidgetListProps {
  type: "add" | "delete";
  detail: RolesDetail[];
  newId: number;
}

function ListRole(this: any, { roleList, setRoleList }: any) {
  const vyu_api_url = process.env.REACT_APP_VYU_API_URL;
  const [rowDataToBeDeleted, setRowDataToBeDeleted] = React.useState<any>();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [rowHeight, setRowHeight] = useState<number>(0);
  const open = Boolean(anchorEl);
  const [selectedFilters, setSelectedFilters] = useState<string[]>([]);
  const [filterValue, setFilterValue] = useState<string>("");
  const Buttons: (params: any) => React.JSX.Element = (
    params: any
  ): React.JSX.Element => (
    <div className="items-justify-center justify-center w-fit">
      <IconButton onClick={() => edit(params)}>
        <EditSvg />
      </IconButton>
      <> </>
      <IconButton onClick={() => deleteRole(params)}>
        <DeleteSvg className="" />
      </IconButton>
    </div>
  );
  const [openPreviewDialog, setOpenPreviewDialog] = React.useState(false);
  const [openPreviewDeleteDialog, setOpenPreviewDeleteDialog] =
    React.useState(false);
  const [rows, setRows] = React.useState<any[]>([{ id: 1 }]);
  const [duplicateRows, setDuplicateRows] = React.useState<any[]>([{ id: 1 }]);
  const [columns, setColumns]: any[] = React.useState<any[]>([
    {
      field: "roleName",
      headerName: "Name",
      width: 200,
      filter: "agTextColumnFilter",
      resizable: true,
      flex: 15,
      cellClass: "first-column",
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 400,
      cellRenderer: Buttons,
      cellRendererParams: {
        edit: edit.bind(this),
        deleteRole: deleteRole.bind(this),
        preview: preview.bind(this),
      },
      resizable: true,
      flex: 25,
      cellClass: "other-column",
    },
  ]);
  const [roleData, setRoleData] = React.useState<any>();
  const apiCallToGetAllRole = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        handleError("Authentication token not found. Please login again.");
        return;
      }
      const response = await fetch(`${vyu_api_url}/role/getAllRoles`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
        },
      });
      const data = await response.json();

      let dataToShow = data.obj;
      setRows(dataToShow);
      setDuplicateRows(dataToShow);
    } catch (error) {
      console.error("Error fetching roles:", error);
      handleError("An unexpected error occurred while fetching roles");
      setRows([]);
      setDuplicateRows([]);
    }
  };
  const calculateRowHeight = () => {
    const vh = window.innerHeight / 100;
    return 6 * vh;
  };
  useEffect(() => {
    const updateRowHeight = () => setRowHeight(calculateRowHeight());
    updateRowHeight();
    window.addEventListener("resize", updateRowHeight);
    return () => window.removeEventListener("resize", updateRowHeight);
  }, []);
  React.useEffect(() => {
    apiCallToGetAllRole();
  }, []);

  const deleteRoleApiCall = async (param: any) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        handleError("Authentication token not found. Please login again.");
        return;
      }

      if (!param?.data?.roleId) {
        handleError("Invalid role ID provided for deletion");
        return;
      }

      const response = await fetch(
        `${vyu_api_url}/role/delete?id=${param.data.roleId}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
          },
        }
      );
      const data = await response.json();
      handleSuccess(data.message || "Role deleted successfully");
      await apiCallToGetAllRole(); // Refresh the list after successful deletion
    } catch (error) {
      console.error("Error deleting role:", error);
      handleError("An unexpected error occurred while deleting the role");
    }
  };
  function edit(params: any) {
    let RoleDetail: RolesDetail = {
      id: params.data.roleId,
      name: params.data.roleName,
    };
    const isPresent = roleList.detail.some(
      (item: RolesDetail) => item.id === RoleDetail.id
    );
    setRoleList({
      type: "add",
      detail: isPresent ? roleList.detail : [...roleList.detail, RoleDetail],
      newId: params.data.roleId,
    });
  }
  const handleWarning = (message: string) => {
    showWarningToast(message);
  };
  const handleSuccess = (message: string) => {
    showSuccessToast(message);
  };
  const handleError = (message: string) => {
    showErrorToast(message);
  };
  function deleteRole(data: any) {
    console.log("data is: ", data, typeof data);

    setOpenPreviewDeleteDialog(true);
    setRowDataToBeDeleted(data);
  }
  function deleteRoleOnConfirmation(data: any, confirmDelete: boolean = false) {
    deleteRoleApiCall(data);
  }
  function preview(data: any) {
    setOpenPreviewDialog(true);
    setRoleData({
      viewType: data.data.viewTypeId.name,
      dataSourceData: data.data,
    });
  }
  const filters: any = {
    Name: "name",
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // Remove a specific filter
  const handleRemoveFilter = (filterKey: string) => {
    setSelectedFilters((prev) => prev.filter((item) => item !== filterKey));
  };

  // Function to add/remove filters
  const toggleFilter = (filter: string) => {
    setSelectedFilters(
      (prevFilters) =>
        prevFilters.includes(filter)
          ? prevFilters.filter((f) => f !== filter) // Remove if already selected
          : [...prevFilters, filter] // Add if not selected
    );
  };

  // Function to apply filters to the row data
  // const applyFilters = (value: string) => {
  //   const lowerCaseValue = value.toLowerCase();

  //   const filteredRows = duplicateRows.filter((item) =>
  //     selectedFilters.some((filter) => {
  //       const cellValue = String(item[filter] ?? "").toLowerCase();
  //       return cellValue.includes(lowerCaseValue);
  //     })
  //   );

  //   setRows(filteredRows);
  // };

  // Function to apply filters to the row data
  const applyFilters = async (searchTerm: string) => {
    try {
      // Construct URL with query parameters
      const params = new URLSearchParams({
        role: searchTerm,
        filter: selectedFilters.join(","), // Join filters array as a comma-separated string
      });
      const response = await fetch(
        `${vyu_api_url}/filter/query/searchRoles?${params}`,
        {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        }
      );

      if (!response.ok) {
        console.error("Server error:", response.status, response.statusText);
        return;
      }

      const data = await response.json();
      console.log("This is inside api", data);

      // Check if the response format includes 'obj' and if 'obj' is not empty
      if (data.status === "Success" && data.obj) {
        if (data.obj.length > 0) {
          setRows(data.obj); // Set rows with the content of 'obj' array
        } else {
          console.log("No results found.");
          setRows([]); // Set rows to an empty array if 'obj' is empty
        }
      } else {
        setRows([]); // Clear rows if the structure is unexpected
      }
    } catch (error) {
      console.error(
        "Error fetching data:",
        error,
        `${vyu_api_url}/filter/query/searchQueries`
      );
    }
  };

  // Modified search filter function
  const handleSearchFilter = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setFilterValue(value);
    // If no filters are selected and input is not empty, apply the search value across all columns
    // if (selectedFilters.length === 0 && value !== "") {
    //   const filteredRows = duplicateRows.filter((item) => {
    //     return Object.keys(item).some((key) => {
    //       const itemValue = item[key];
    //       return (
    //         typeof itemValue === "string" &&
    //         itemValue.toLowerCase().includes(value.toLowerCase())
    //       );
    //     });
    //   });
    //   setRows(filteredRows);
    //   return;
    // }
    // If input is empty, apply all selected filters
    if (value.length >= 2 ) {
      // Apply the filter to get updated rows
      applyFilters(value);
    } else {
       setRows(duplicateRows);
    }
  };

  const getRowStyle = (params: any) => {
    if (params.node.rowIndex % 2 !== 0) {
      return { background: "#F5F7F8", height: "10px", display: "flex" };
    } else {
      return { background: "#FCFCFC", height: "10px", display: "flex" };
    }
  };
  return (
    <>
      {/* <div className='access-form-mapping-header'>
            <div className='access-form-mapping-tab'>
                <div className='access-form-mapping-tab-inner'>
                    <div className='access-form-mapping-tab-text'>
                        Data Source
                    </div>
                </div>
                <div className='access-form-mapping-tab-line'/>
            </div>
      </div> */}
      <CardHeader>
        <Breadcrumb
          list={[
            { title: "Roles", to: "" },
            { title: "List", to: "" },
          ]}
        />
      </CardHeader>
      <div style={{ paddingLeft: "2vh" }}>
        {/* <WidgetPreview
          open={openPreviewDialog}
          onclose={() => setOpenPreviewDialog(false)}
          data={dataSourceData}
        /> */}

        <DeletePrompt
          component={"Roles"}
          dataToBeDeleted={rowDataToBeDeleted}
          open={openPreviewDeleteDialog}
          onclose={() => setOpenPreviewDeleteDialog(false)}
          confirmCallBack={deleteRoleOnConfirmation}
          data={roleData}
        />
        {/* <div className="font-semibold  text-3xl  italic items-justify-center">
          <h1 className="font-semibold  text-3xl pb-2 italic  items-center ">
            <span
              style={{
                color: "#201C34",
                // fontFamily: "SF Pro Display",
                fontSize: "30px",
                // fontStyle: "italic",
                fontWeight: 600,
                lineHeight: "normal",
              }}
            >
              Roles
            </span>
          </h1>
        </div> */}
        <div>
          <SearchInput
            filterValue={filterValue}
            onSearchChange={handleSearchFilter}
            selectedFilters={selectedFilters}
          />
          <FilterMenu
            filters={filters}
            selectedFilters={selectedFilters}
            onToggleFilter={toggleFilter}
            onRemoveFilter={handleRemoveFilter}
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            onOpen={handleClick}
          />
        </div>
      </div>
      <div
        style={{
          width: "100%",
          fontSize: 14,
          // fontStyle: "italic",
        }}
      >
        <div className="grid-div">
          <AgGridReact
            className="ag-theme-quartz ag-theme-quartz-listWidget"
            rowData={rows}
            columnDefs={columns}
            pagination={true}
            paginationPageSize={10}
            paginationPageSizeSelector={false}
            rowHeight={rowHeight}
            getRowStyle={getRowStyle}
          />
        </div>
      </div>
      <ToastComponent />
    </>
  );
}
const styleObj = {
  backgroundColor: "#F3F1FF",
  "text-transform": "capitalize",
  "font-style": "italic",
  border: "2px solid #998CEB",
  color: "black",
  height: "36px",
  "&:hover": {
    backgroundColor: "#F3F1FF",
  },
  // "&:active": {
  //   backgroundColor: "pink"
  // }
};

export default ListRole;
